import { render, staticRenderFns } from "./InputActionPassword.vue?vue&type=template&id=1522cca9&scoped=true&lang=pug&"
import script from "./InputActionPassword.vue?vue&type=script&lang=ts&"
export * from "./InputActionPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522cca9",
  null
  
)

export default component.exports